export type BrandId = 'republic' | 'verdant'

export interface BrandImages {
  hero: string
  heroSecondary: string
  clinician: string
  labKit: string
  /** Per-product overrides keyed by slug. Falls back to the shared catalogue image. */
  products: Record<string, string>
}

export interface BrandCopy {
  utilityLeft: string
  utilityRight: string
  heroTitle: [string, string]
  heroSubhead: string
  manifesto: string
  ctaIntro: string
  metaTitle: string
  metaDescription: string
  legalName: string
}

export interface Brand {
  id: BrandId
  name: string
  wordmark: string
  /** Sits under the wordmark in the footer and the identity lockup. */
  tagline: string
  wordmarkCase: 'upper' | 'title'
  monogram: string
  mark: 'monogram' | 'leaf'
  copy: BrandCopy
  images: BrandImages
}

export const brands: Record<BrandId, Brand> = {
  republic: {
    id: 'republic',
    name: 'Republic',
    wordmark: 'REPUBLIC',
    tagline: 'Making healthcare more affordable',
    wordmarkCase: 'upper',
    monogram: 'R',
    mark: 'monogram',
    copy: {
      utilityLeft: 'Real doctors, licensed in all 50 states',
      utilityRight: 'Membership $39/mo · Same price for a year',
      heroTitle: ['Making healthcare', 'more affordable.'],
      heroSubhead: 'Clinician-guided care. Clear pricing. No surprises on the invoice.',
      manifesto: 'Better health, brighter tomorrows.',
      ctaIntro:
        'Answer three questions and we will take it from there. Nothing is charged until a doctor has read your labs and you have said yes.',
      metaTitle: 'Republic — Making healthcare more affordable',
      metaDescription:
        'Clinician-guided peptide and metabolic care with the prices in the open. Labs first, a plan you approve, medication from US-licensed pharmacies.',
      legalName: 'Republic Health, Inc.',
    },
    images: {
      hero: 'https://cdn.magicpatterns.com/patterns/generated-images/fdbe885c-e494-4ec5-b9e6-47e98ba13ef7.jpg',
      heroSecondary:
        'https://cdn.magicpatterns.com/patterns/generated-images/bf4ef3af-19d4-4543-a925-9ce8b5503c9c.jpg',
      clinician:
        'https://cdn.magicpatterns.com/patterns/generated-images/bff842fc-0442-485f-b4c9-fe253b29a861.jpg',
      labKit:
        'https://cdn.magicpatterns.com/patterns/generated-images/1f48c623-b8ad-4d8e-84e3-71e44883a1a0.jpg',
      products: {},
    },
  },

  verdant: {
    id: 'verdant',
    name: 'Verdant',
    wordmark: 'Verdant',
    tagline: 'Care that grows with you',
    wordmarkCase: 'title',
    monogram: 'V',
    mark: 'leaf',
    copy: {
      utilityLeft: 'Real doctors, licensed in all 50 states',
      utilityRight: 'Membership $39/mo · Cancel any time',
      heroTitle: ['Care that grows', 'with you.'],
      heroSubhead: 'Doctor-led care, delivered. Clear pricing, start to finish.',
      manifesto: 'Better health, one steady step at a time.',
      ctaIntro:
        'Answer three questions and we will take it from there. Nothing is charged until a doctor has read your labs and you have said yes.',
      metaTitle: 'Verdant — Care that grows with you',
      metaDescription:
        'Clinician-led peptide and metabolic care delivered to your door, with lab work and pricing you can see up front.',
      legalName: 'Verdant Health, Inc.',
    },
    images: {
      hero: 'https://cdn.magicpatterns.com/patterns/generated-images/589a81df-684d-4c7b-a1bc-bb64b0951af3.jpg',
      heroSecondary:
        'https://cdn.magicpatterns.com/patterns/generated-images/88cce9fe-671a-4475-9020-761739a29759.jpg',
      clinician:
        'https://cdn.magicpatterns.com/patterns/generated-images/e206c78e-8a2e-407e-bde1-b495615e4dc8.jpg',
      labKit:
        'https://cdn.magicpatterns.com/patterns/generated-images/13a34ce5-9abc-49d9-9f92-06e664abf0d8.jpg',
      products: {},
    },
  },
}
